import React from 'react';
import clsx from 'clsx';

const Icon = (props) => {
    const { name, size = 20, className, style, rotate, spin, onClick, onMouseEnter } = props;

    return (
        <span
            className={clsx(
                'material-symbols-rounded',
                { 'animate-spin': spin },
                className
            )}
            style={{
                transform: rotate && `rotate(${rotate}deg)`,
                fontSize: size,
                ...style
            }}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
        >
            {name}
        </span>
    );
};

export default Icon;
